import type { JobDto, JobImprovedDto } from './job.dto';

export type JobViewModel = {
  jobTitle: string | null;
  jobPreview: string | null;
  coordinates: { lat: number; lon: number } | null;
  dto: JobDto;
};

export type JobImprovedViewModel = JobImprovedDto & {
  jobTitle: string;
  updatedAt: string;
};

export enum JobQuality {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
}

const toCoordinates = (data: JobDto): { lat: number; lon: number } | null => {
  const latitude = data.latitude ? parseFloat(data.latitude) : null;
  const longitude = data.longitude ? parseFloat(data.longitude) : null;

  return latitude && longitude ? { lat: latitude, lon: longitude } : null;
};

export const toJobViewModel = (data: JobDto): JobViewModel => {
  return {
    jobTitle: data.job_title,
    jobPreview: data.job_preview,
    coordinates: toCoordinates(data),
    dto: data,
  };
};

export const toJobImprovedViewModel = (data: JobImprovedDto): JobImprovedViewModel => {
  return {
    ...data,
    jobTitle: data.job_details.job_title ?? data.origin_job_title ?? '',
    updatedAt: data.updated_at,
  };
};
